import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import ReactTimeAgo from 'react-time-ago';

import InputTextareaBar from '../../util/InputTextareaBar.jsx';
import InputTextBar from '../../util/InputTextBar.jsx';

const DataRowWrapper = styled.div`
    margin: 0;
`;

const StaticName = styled.div`
    display: inline-block;
    font-weight: bold;
    margin-right: 0.5rem;
`;

const EditableName = styled.div`
    display: inline-block;
    font-weight: bold;
    color: blue;
    margin-right: 0.5rem;
    cursor: pointer;
`;

const EditableValue = styled.div`
    display: inline-block;
    cursor: pointer;
`;

const StaticValue = styled.div`
    display: inline-block;
    font-family: Courier;
    font-weight: bold;
`;

export class DataRow extends Component {

    static propTypes = {
        item_data: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        can_edit: PropTypes.bool,
        field_type: PropTypes.string,
        field_extra: PropTypes.element,
        update_item: PropTypes.func,
    }

    static defaultProps = {
        can_edit: false,
        field_type: "text",
        field_extra: null,
        update_item: null,
    }

    state = {
        item_data: this.props.item_data,
        in_field_edit: false
    };

    toggle_edit() {
        this.setState({
            in_field_edit: !this.state.in_field_edit,
        })
    }

    ok_field_value_edit = (value) => {
        this.props.update_item(value);
        this.setState({in_field_edit: false})
    }

    cancel_field_value_edit = () => {
        this.setState({in_field_edit: false})
    }

    render() {
        if (!this.state.item_data[this.props.name] && !this.props.can_edit) {
            return '';
        }
        let value_data = this.state.item_data[this.props.name] ? this.state.item_data[this.props.name] : '';
        if (this.props.field_type === "time") {
            value_data = <ReactTimeAgo date={value_data}/>
        }
        const left_side = this.props.can_edit ?
            <EditableName onClick={e => this.toggle_edit()}>{this.props.name}:</EditableName> :
            <StaticName>{this.props.name}:</StaticName>;
        let editable_value = <EditableValue>{value_data}</EditableValue>;
        if (this.props.can_edit) {
            editable_value = <EditableValue
                onClick={e => this.toggle_edit()}>
                {value_data}
            </EditableValue>;
            if (this.state.in_field_edit) {
                switch (this.props.field_type) {
                    case "textarea":
                        editable_value = <InputTextareaBar
                            initial_value={value_data}
                            callback_ok={value => this.ok_field_value_edit(value)}
                            callback_cancel={this.cancel_field_value_edit}/>
                        break;
                    default:
                    case "text":
                    case "link":
                        console.log("initial_value",value_data)
                        editable_value = <InputTextBar
                            initial_value={value_data}
                            callback_ok={value => this.ok_field_value_edit(value)}
                            callback_cancel={this.cancel_field_value_edit}/>
                        break;
                }
            }
        }
        const right_side = this.props.can_edit ? editable_value : <StaticValue>{value_data}</StaticValue>
        return <DataRowWrapper>
            {left_side}{right_side}{this.props.field_extra}
        </DataRowWrapper>
    }
}

export default DataRow;

